import { TemporaryFile } from './temporary-file.model';

export const fileToTemporaryFile = (file: File, id: string): TemporaryFile => ({
    uuid: id,
    originalFile: file,
    originalFileName: file.name,
    type: file.type,
});
